import { SessionStatus } from '@/infra/sse/status'
import { useStatusContext } from '@/features/status'

export function useSessionStatus(sessionId: string): SessionStatus | null {
  const { getSessionStatus } = useStatusContext()
  return getSessionStatus(sessionId)
}
